import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtField.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "order-info font-size-h3-normal"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("593"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.tmpl_name || '-') + " ")])]), _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("69"))]), _c('div', {
    staticClass: "field-line-value",
    staticStyle: {
      "word-break": "normal",
      "width": "10rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.server_name || '-') + " ")])]), _vm.orderInfo.o_img_view === 1 ? _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("410"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._l(_vm.remarkPicList, function (item, index) {
    return _c('img', {
      key: index,
      staticClass: "img",
      attrs: {
        "src": item.img_url
      },
      on: {
        "click": function ($event) {
          return _vm.show(index);
        }
      }
    });
  }), _vm.remarkPicList.length === 0 ? _c('span', [_vm._v("-")]) : _vm._e()], 2)]) : _vm._e(), _vm.orderInfo.o_descri_view === 1 ? _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("160"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.detail_desc || '-') + " ")])]) : _vm._e()]), _c(__unplugin_components_0, {
    attrs: {
      "extFields": _vm.orderExtFields
    }
  }), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('Previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.remarkPicListForPreviewer,
      "options": _vm.options
    }
  })], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };